import Login from "./Login";
import History from "./History";

export default { Login, History };



// WEBPACK FOOTER //
// ./src/containers/Mypage/index.js